import React from 'react';

export default function TasksHeader() {
    return (
        <>
            <h1 className="text-center text-2xl font-bold text-gray-900">Task Management</h1>
            <p className="mb-8 text-center text-sm text-gray-500">View and manage your scheduled content publishing tasks</p>
        </>
    );
}

